var _a;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _palette$text, _palette$text2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { autocompleteClasses, buttonClasses } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { handleBreakpoints } from '@mui/system';
import { breakpoints } from "./breakpoints";
import Colors, { error, info, secondary } from "./colors";
import { BorderRadiusVariants } from "./dimensions";
import palette from "./palette";
import typography, { FontSizeVariants, FontWeightVariants } from "./typography";
import { MuiChipTheme } from "./variants";
var theme = createTheme({
    palette: palette,
    typography: typography,
    breakpoints: breakpoints,
    components: {
        MuiButton: {
            defaultProps: {
                size: 'small'
            },
            styleOverrides: {
                root: _objectSpread({
                    textTransform: "none",
                    borderRadius: "8px",
                    minWidth: 'fit-content',
                    minHeight: 'fit-content',
                    border: 'none !important'
                }, FontWeightVariants.medium),
                sizeSmall: _objectSpread({
                    padding: '8px 12px',
                    gap: '4px'
                }, FontSizeVariants.base),
                sizeMedium: _objectSpread({
                    padding: '10px 14px',
                    gap: '4px'
                }, FontSizeVariants.base),
                sizeLarge: _objectSpread({
                    padding: '10px 16px',
                    gap: '6px'
                }, FontSizeVariants.lg),
                // contained: {
                //   border: '1px solid',
                //   borderColor: 'transparent'
                // },
                outlined: function (_ref) {
                    var _a;
                    var _ownerState$color;
                    var ownerState = _ref.ownerState;
                    var currColor = (_ownerState$color = ownerState.color) !== null && _ownerState$color !== void 0 ? _ownerState$color : 'primary';
                    return _a = {
                            outlineOffset: -1,
                            outline: '1px solid',
                            backgroundColor: 'white',
                            outlineColor: currColor !== 'inherit' ? Colors[currColor][200] : 'inherit'
                        },
                        _a["&.".concat(buttonClasses.disabled)] = {
                            outlineColor: secondary[200]
                        },
                        _a;
                },
                endIcon: {
                    margin: 0,
                    fontSize: 20,
                    '& >*:nth-of-type(1)': {
                        fontSize: 'inherit'
                    }
                },
                startIcon: {
                    margin: 0,
                    fontSize: 20,
                    '& >*:nth-of-type(1)': {
                        fontSize: 'inherit'
                    }
                }
            },
            variants: [{
                    props: {
                        size: 'icon'
                    },
                    style: {
                        padding: '8px'
                    }
                }]
        },
        MuiSelect: {
            defaultProps: {
                color: "primary"
            },
            styleOverrides: {
                select: {
                    fontSize: "14px",
                    height: "auto"
                },
                root: {
                    borderRadius: "8px"
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: function (_ref2) {
                    var theme = _ref2.theme;
                    return _objectSpread(_objectSpread({
                        padding: '0px 12px',
                        columnGap: '8px',
                        borderRadius: '8px',
                        backgroundColor: 'white'
                    }, FontSizeVariants.lg), {}, {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: secondary[200] // Change this to your desired color
                        },
                        '&.Mui-focused': {
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: info[200],
                                borderWidth: 1
                            },
                            boxShadow: "0px 0px 0px 4px ".concat(info[500], "3D"),
                            '&.Mui-error': {
                                boxShadow: "0px 0px 0px 4px ".concat(error[500], "3D")
                            }
                        },
                        '&.Mui-error': {
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: error[200]
                            }
                        },
                        '&.Mui-disabled': {
                            background: secondary[50],
                            '& .MuiOutlinedInput-input': {
                                '-webkit-text-fill-color': theme.palette.text.tertiary
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: secondary[200]
                            }
                        }
                    });
                },
                input: {
                    padding: '8px 0px',
                    height: 'auto',
                    '&:-webkit-autofill': {
                        color: (_palette$text = palette.text) === null || _palette$text === void 0 ? void 0 : _palette$text.primary,
                        '-webkit-text-fill-color': (_palette$text2 = palette.text) === null || _palette$text2 === void 0 ? void 0 : _palette$text2.primary,
                        backgroundClip: 'text',
                        '-webkit-background-clip': 'text !important'
                    }
                },
                sizeSmall: _objectSpread({}, FontSizeVariants.base),
                notchedOutline: {
                    borderWidth: '1px',
                    borderColor: secondary[200],
                    boxShadow: '0px 1px 2px 0px #1018280D'
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                size: 'small'
            }
            // ...MuiTextFieldTheme
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: function (_ref3) {
                    var theme = _ref3.theme;
                    return theme.unstable_sx({
                        mx: 0
                    });
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: secondary[200],
                    "&.Mui-disabled": {
                        "color": secondary[200]
                    }
                }
            }
        },
        MuiCircularProgress: {
            defaultProps: {
                thickness: 4
            }
        },
        MuiSvgIcon: {
            defaultProps: {
                sx: {
                    height: 20,
                    width: 20
                }
            },
            styleOverrides: {
                colorSecondary: function (_ref4) {
                    var theme = _ref4.theme;
                    return theme.unstable_sx({
                        color: 'secondary.600'
                    });
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                listbox: (_a = {
                        padding: '4px 6px'
                    },
                    _a[".".concat(autocompleteClasses.option)] = {
                        padding: '8px'
                    },
                    _a),
                option: _objectSpread(_objectSpread({}, FontSizeVariants.base), {}, {
                    margin: '1px 0px',
                    borderRadius: '6px',
                    minHeight: 'auto',
                    '&[aria-selected="true"]': {
                        backgroundColor: info[50]
                    }
                }),
                tag: function (_ref5) {
                    var theme = _ref5.theme;
                    return theme.unstable_sx({
                        mx: 0,
                        maxWidth: '100%'
                    });
                },
                paper: function (_ref6) {
                    var theme = _ref6.theme;
                    return theme.unstable_sx({
                        mt: 0.5,
                        borderRadius: 2
                    });
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: function (_ref7) {
                    var theme = _ref7.theme;
                    return theme.unstable_sx({
                        fontWeight: 'strong',
                        textTransform: 'none',
                        color: 'text.secondary',
                        minHeight: 'auto',
                        py: 1.5,
                        px: 0.5,
                        minWidth: 'auto'
                    });
                }
                // textColorSecondary: ({ theme }) => theme.unstable_sx({
                //   '&.Mui-selected': {
                //     color: 'text.primary'
                //   },
                // }),
                // selected: ({ theme, ownerState }) => theme.unstable_sx({
                //   color
                // }),
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: function (_ref8) {
                    var theme = _ref8.theme;
                    return theme.unstable_sx({
                        minHeight: 'auto'
                    });
                },
                indicator: function (_ref9) {
                    var theme = _ref9.theme, indicatorColor = _ref9.ownerState.indicatorColor;
                    return theme.unstable_sx({
                        bgcolor: indicatorColor === 'secondary' ? 'secondary.200' : undefined
                    });
                },
                flexContainer: function (_ref10) {
                    var theme = _ref10.theme;
                    return theme.unstable_sx({
                        columnGap: 1
                    });
                }
            }
        },
        MuiChip: MuiChipTheme,
        MuiAvatar: {
            defaultProps: {
                imgProps: {
                    loading: 'lazy'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: function (_ref11) {
                    var theme = _ref11.theme;
                    return theme.unstable_sx({
                        borderRadius: 1.5
                    });
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: function (_ref12) {
                    var ownerState = _ref12.ownerState, theme = _ref12.theme;
                    return theme.unstable_sx({
                        py: {
                            xs: 1.5,
                            sm: 2
                        },
                        px: {
                            xs: 1.5,
                            sm: 2.5
                        },
                        gap: {
                            xs: 2,
                            sm: 2.5
                        },
                        borderRadius: !ownerState.square ? 2 : undefined
                    });
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: function (_ref13) {
                    var ownerState = _ref13.ownerState, theme = _ref13.theme;
                    return theme.unstable_sx({
                        fontWeight: 'strong',
                        fontSize: 'base',
                        p: 0
                    });
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: function (_ref14) {
                    var ownerState = _ref14.ownerState, theme = _ref14.theme;
                    return theme.unstable_sx({
                        borderRadius: 2
                    });
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                root: {
                    zIndex: 1300
                }
            }
        }
    },
    unstable_sxConfig: {
        fontWeight: {
            style: function (props) {
                var styleFromPropValue = function (fontWeight) {
                    var _FontWeightVariants$f;
                    return (_FontWeightVariants$f = FontWeightVariants[fontWeight]) !== null && _FontWeightVariants$f !== void 0 ? _FontWeightVariants$f : {
                        fontWeight: fontWeight
                    };
                };
                return handleBreakpoints(props, props.fontWeight, styleFromPropValue);
            }
        },
        fontSize: {
            style: function (props) {
                var styleFromPropValue = function (fontSize) {
                    var _FontSizeVariants$fon;
                    return (_FontSizeVariants$fon = FontSizeVariants[fontSize]) !== null && _FontSizeVariants$fon !== void 0 ? _FontSizeVariants$fon : {
                        fontSize: fontSize
                    };
                };
                return handleBreakpoints(props, props.fontSize, styleFromPropValue);
            }
        },
        borderRadius: {
            style: function (props) {
                var styleFromPropValue = function (borderRadius) {
                    var _BorderRadiusVariants;
                    var radius = (_BorderRadiusVariants = BorderRadiusVariants[borderRadius]) !== null && _BorderRadiusVariants !== void 0 ? _BorderRadiusVariants : borderRadius;
                    if (typeof radius === 'number') {
                        return {
                            borderRadius: props.theme.shape.borderRadius * radius
                        };
                    }
                    return {
                        borderRadius: radius
                    };
                };
                return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
            }
        }
    },
    zIndex: {
        modal: 1200,
        drawer: 1200
    }
});
export default theme;
